@if(common.isMobileDevice && false){
  <div class="row">
    <div class="col-12">
      <div class="blocking-message-wrapper">
        <img src="assets/images/logo.png" alt="Logo">

        <div class="blocking-message">
          <div class="icon">&#9888;</div>
          Valzy is optimized for Desktop and Tablet use.
          Please switch to appropriate device type.
        </div>
      </div>
    </div>
  </div>
}@else{
  <app-header>Header</app-header>
  <div class="container p-0">
      <div class="col-sm-12">
          <div class="row d-flex">
              <div class="col-md-12">
                  <router-outlet></router-outlet>
              </div>
          </div>
      </div>
  </div>
}
